import { render } from "./Object.component.vue?vue&type=template&id=7333c04c"
import script from "./Object.component.vue?vue&type=script&lang=js"
export * from "./Object.component.vue?vue&type=script&lang=js"

import exportComponent from "/home/debian/oni-ui/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__